import React from "react";
import { FieldRenderProps } from "react-final-form";

import RadioButtonGroup, {
  RadioButtonExternalProps,
} from "components/Input/RadioButtonGroup";

import withFieldControl from "../FieldControl";

type DictionaryItem = {
  value: any;
  label: string;
};

type Props = {
  required?: boolean;
} & RadioButtonExternalProps &
  FieldRenderProps<any>;

class RadioButtonGroupControl extends React.Component<Props> {
  onChange = (item: DictionaryItem) => {
    const {
      input: { onChange },
    } = this.props;

    const event: any = { target: { value: item?.value } };
    onChange(event);
  };

  render() {
    const { input, meta, required, validate, ...props } = this.props;
    const error = (meta.touched || meta.dirty) && meta.error;

    return (
      <RadioButtonGroup
        input={input}
        onChange={this.onChange}
        error={error}
        required={required}
        {...props}
      />
    );
  }
}

export default withFieldControl(RadioButtonGroupControl);
